import { render } from "./ProscanUploadBatchPanel.vue?vue&type=template&id=66730310&scoped=true"
import script from "./ProscanUploadBatchPanel.vue?vue&type=script&lang=js"
export * from "./ProscanUploadBatchPanel.vue?vue&type=script&lang=js"

import "./ProscanUploadBatchPanel.vue?vue&type=style&index=0&id=66730310&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66730310"]])

export default __exports__